import { render, staticRenderFns } from "./AdvertisingCost.vue?vue&type=template&id=4bf799d2&scoped=true"
import script from "./AdvertisingCost.vue?vue&type=script&lang=js"
export * from "./AdvertisingCost.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingCost.vue?vue&type=style&index=0&id=4bf799d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf799d2",
  null
  
)

export default component.exports